module.exports = __webpack_public_path__ + "img/2_126.36db015c.png";